export default __webpack_public_path__ + "static/save_win-7139c8d3e12f46c870228e246d305d29.webp";